<div
  class="tw:w-[296px] tw:max-w-[296px] tw:overflow-hidden tw:rounded-xl tw:bg-white tw:font-(--font-family) tw:text-(--color-text) tw:shadow-[0_4px_16px_rgba(0,0,0,0.14)]"
>
  <div class="tw:flex tw:flex-col tw:gap-3 tw:px-4 tw:pb-2 tw:pt-4">
    <span class="tw:text-xs tw:font-medium tw:text-(--color-gray-secondary)">
      {{ 'components.date-input.time.selectTime' | transloco }}
    </span>

    <div class="tw:flex tw:items-stretch tw:gap-1.5">
      <input
        #hourInput
        type="text"
        inputmode="numeric"
        maxlength="2"
        class="omm-clock-digit tw:h-14 tw:min-w-0 tw:flex-1 tw:cursor-text tw:select-text tw:rounded-[10px] tw:border tw:border-(--color-border) tw:bg-(--color-mid-gray) tw:text-center tw:text-[32px] tw:font-medium tw:leading-none tw:text-(--color-text) tw:outline-hidden tw:transition-[background-color,border-color,color] tw:duration-150 tw:ease-in-out"
        [ngClass]="
          mode === 'hour'
            ? 'tw:border-blue-main! tw:bg-blue-main! tw:text-white!'
            : ''
        "
        [value]="displayHour"
        (mousedown)="onDigitMouseDown($event)"
        (focus)="onHourFocus($event)"
        (blur)="onHourBlur()"
        (input)="onHourInput($any($event.target).value)"
        (keydown)="onHourKeydown($event)"
        aria-label="Hour"
      />
      <span
        class="tw:flex tw:items-center tw:px-0.5 tw:text-[32px] tw:font-medium tw:text-(--color-gray-secondary)"
        aria-hidden="true"
        >:</span
      >
      <input
        #minuteInput
        type="text"
        inputmode="numeric"
        maxlength="2"
        class="omm-clock-digit tw:h-14 tw:min-w-0 tw:flex-1 tw:cursor-text tw:select-text tw:rounded-[10px] tw:border tw:border-(--color-border) tw:bg-(--color-mid-gray) tw:text-center tw:text-[32px] tw:font-medium tw:leading-none tw:text-(--color-text) tw:outline-hidden tw:transition-[background-color,border-color,color] tw:duration-150 tw:ease-in-out"
        [ngClass]="
          mode === 'minute'
            ? 'tw:border-blue-main! tw:bg-blue-main! tw:text-white!'
            : ''
        "
        [value]="displayMinute"
        (mousedown)="onDigitMouseDown($event)"
        (focus)="onMinuteFocus($event)"
        (blur)="onMinuteBlur()"
        (input)="onMinuteInput($any($event.target).value)"
        (keydown)="onMinuteKeydown($event)"
        aria-label="Minute"
      />

      <div
        class="tw:flex tw:w-[52px] tw:shrink-0 tw:flex-col tw:overflow-hidden tw:rounded-[10px] tw:border tw:border-(--color-border)"
        role="group"
      >
        <button
          type="button"
          class="tw:flex-1 tw:cursor-pointer tw:border-0 tw:bg-white tw:text-xs tw:font-semibold tw:tracking-[0.02em] tw:text-(--color-gray-secondary) tw:transition-[background-color,color] tw:duration-150 tw:ease-in-out tw:disabled:cursor-not-allowed tw:disabled:opacity-40"
          [ngClass]="!isPm ? 'tw:bg-blue-main! tw:text-white!' : ''"
          [disabled]="isAmDisabled()"
          (click)="setAmPm(false)"
          [attr.aria-pressed]="!isPm"
        >
          {{ 'components.date-input.time.am' | transloco }}
        </button>
        <button
          type="button"
          class="tw:flex-1 tw:cursor-pointer tw:border-0 tw:border-t tw:border-(--color-border) tw:bg-white tw:text-xs tw:font-semibold tw:tracking-[0.02em] tw:text-(--color-gray-secondary) tw:transition-[background-color,color] tw:duration-150 tw:ease-in-out tw:disabled:cursor-not-allowed tw:disabled:opacity-40"
          [ngClass]="isPm ? 'tw:bg-blue-main! tw:text-white!' : ''"
          [disabled]="isPmDisabled()"
          (click)="setAmPm(true)"
          [attr.aria-pressed]="isPm"
        >
          {{ 'components.date-input.time.pm' | transloco }}
        </button>
      </div>
    </div>
  </div>

  <div
    class="tw:flex tw:touch-none tw:select-none tw:justify-center tw:px-4 tw:pb-4 tw:pt-2"
    (pointerdown)="onDialPointerDown($event)"
    (pointermove)="onDialPointerMove($event)"
    (pointerup)="onDialPointerUp($event)"
    (pointercancel)="onDialPointerUp($event)"
  >
    <div
      class="tw:relative tw:h-[232px] tw:w-[232px] tw:rounded-full tw:bg-(--color-mid-gray)"
    >
      <div
        class="omm-clock-hand"
        [style.transform]="'rotate(' + handAngleDeg + 'deg)'"
      ></div>
      <span
        class="tw:pointer-events-none tw:absolute tw:left-1/2 tw:top-1/2 tw:z-2 tw:-ml-1 tw:-mt-1 tw:h-2 tw:w-2 tw:rounded-full tw:bg-blue-main"
        aria-hidden="true"
      ></span>

      @if (mode === 'hour') {
        @for (h of hours; track h) {
          <button
            type="button"
            class="tw:absolute tw:left-1/2 tw:top-1/2 tw:z-3 tw:flex tw:h-9 tw:w-9 tw:cursor-pointer tw:items-center tw:justify-center tw:rounded-full tw:border-0 tw:bg-transparent tw:text-sm tw:font-medium tw:text-(--color-text) tw:disabled:cursor-not-allowed tw:disabled:opacity-35"
            [ngClass]="
              isHourSelected(h)
                ? 'tw:z-4 tw:font-semibold tw:text-white!'
                : ''
            "
            [ngStyle]="dialNumberStyle(h, 'hour')"
            [disabled]="isHourDisabled(h)"
            (click)="setHour(h); $event.stopPropagation()"
          >
            {{ h }}
          </button>
        }
      } @else {
        @for (m of minuteMarks; track m) {
          <button
            type="button"
            class="tw:absolute tw:left-1/2 tw:top-1/2 tw:z-3 tw:flex tw:h-9 tw:w-9 tw:cursor-pointer tw:items-center tw:justify-center tw:rounded-full tw:border-0 tw:bg-transparent tw:text-sm tw:font-medium tw:text-(--color-text) tw:disabled:cursor-not-allowed tw:disabled:opacity-35"
            [ngClass]="
              isMinuteSelected(m)
                ? 'tw:z-4 tw:font-semibold tw:text-white!'
                : ''
            "
            [ngStyle]="dialNumberStyle(m, 'minute')"
            [disabled]="isMinuteDisabled(m)"
            (click)="setMinute(m); $event.stopPropagation()"
          >
            {{ m.toString().padStart(2, '0') }}
          </button>
        }
      }
    </div>
  </div>

  <div
    class="tw:flex tw:justify-end tw:gap-1 tw:border-t tw:border-(--color-border-light) tw:px-3 tw:pb-3 tw:pt-1"
  >
    <button
      type="button"
      class="tw:cursor-pointer tw:rounded-md tw:border-0 tw:bg-transparent tw:px-3.5 tw:py-2 tw:text-sm tw:font-semibold tw:text-blue-main tw:hover:bg-(--color-blue-bg-light)"
      (click)="cancelClick()"
    >
      {{ 'core.buttons.cancel' | transloco }}
    </button>
    <button
      type="button"
      class="tw:cursor-pointer tw:rounded-md tw:border-0 tw:bg-transparent tw:px-3.5 tw:py-2 tw:text-sm tw:font-semibold tw:text-blue-main tw:hover:bg-(--color-blue-bg-light)"
      (click)="confirm()"
    >
      {{ 'core.buttons.ok' | transloco }}
    </button>
  </div>
</div>
